import { render, staticRenderFns } from "./courseAnnual.vue?vue&type=template&id=1376a664&"
import script from "./courseAnnual.vue?vue&type=script&lang=js&"
export * from "./courseAnnual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports